module.exports = __webpack_public_path__ + "static/media/doc10.416b982c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc10.png
// module id = 62
// module chunks = 0